import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { TablesDisplayGridRowDataFragmentGql } from './TablesDisplayGridRowDataFragmentGql';

export const FlowDownstreamTablesFilteredByFlowOutputFieldQueryGql: DocumentNode = gql`
query FlowDownstreamTablesFilteredByFlowOutputFieldQuery(
  $flowVizportalUrlId: String!,
  $selectedFlowOutputFieldId: ID!,
  $first: Int!,
  $offset: Int!,
  $orderBy: DatabaseTableSortOrder!,
  $publishedConnectionsLineageEnabled: Boolean!
) {
  flows(filter: { vizportalUrlId: $flowVizportalUrlId }) {
    outputFieldsConnection(filter: { id: $selectedFlowOutputFieldId }) {
      nodes {
        downstreamTablesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...TablesDisplayGridRowDataFragment
          }
        }
        maxDownstreamDatasources: downstreamTablesConnection(
          orderBy: { field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC }
          first: 1
        ) {
          nodes {
            downstreamDatasourcesConnection { totalCount }
          }
        }
        maxDownstreamWorkbooks: downstreamTablesConnection(
          orderBy: { field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC }
          first: 1
        ) {
          nodes {
            downstreamWorkbooksConnection { totalCount }
          }
        }
      }
    }
  }
}
${TablesDisplayGridRowDataFragmentGql}
`;
